<template>
  <div id="ScreenFirstFloorSecondItem">
    <div class="left-lists">
      <div class="item" v-for="item in itemLists">
        <p class="name">{{ item.name }}</p>
        <span class="count BoldAlternate">{{ isNaN(item.count)?item.count:numberSplitWithComma(item.count) }}</span>
        <div class="super-name-wrap" v-if="checkUndefineAndNull(item.superCount)">
          <span class="super-name">本月新增</span>
          <span class="super-count">+{{ numberSplitWithComma(item.superCount) }}</span>
        </div>
      </div>
    </div>
    <div class="right-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  name: 'ScreenFirstFloorSecondItem',
  props: {
    itemLists: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="stylus">
#ScreenFirstFloorSecondItem
  height:100%
  display: flex;
  .left-lists
    width 7.5rem
    height 100%
    display: flex
    flex-direction: column
    justify-content: space-between
    .item:last-child
      margin-bottom auto
    .item+.item
      margin-top: 1.5rem
  .item
    .name
      color: rgba(255, 255, 255, 0.8)
      font-size .95rem
      margin-bottom: .4rem
    .count
      color: rgba(255, 255, 255, 1)
      font-size 1.45rem
      display inline-block
      height 1.68rem
      line-height: 1.68rem
    .super-name-wrap
      font-size: .75rem
      margin-top: .3rem
      .super-name
        color rgba(255, 255, 255, 0.6)
      .super-count
        color rgba(24, 105, 255, 1)
        margin-left: .25rem
  .right-wrapper
    flex-grow: 1
</style>
